import React, { useEffect } from "react";
import { Form, Input } from "antd";
import FormItem from "components/fields/FormItem";
import TextArea from "antd/es/input/TextArea";
import { connect, useSelector } from "react-redux";
import {
  doLeaveApproval,
} from "../../../../../redux/leave/leaveState";
import { MODULE_LEAVE_REQUESTS } from "variables/constants";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import {
  CircleCheck, CircleX
} from "lucide-react"

export const LVE_APPROVED = 71;
export const LVE_DECLINED = 72;

const LeaveApprovalForm = ({
  recordData,    
  mode = "edit",
  action,     
  doApproval,
  onCancel,
}) => {
  const [form] = Form.useForm();
  const authUser = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (recordData) {
      form.setFieldsValue({
        lve_id: recordData.lve_id,
        lve_status_id: recordData.lve_status_id,
      });
    }
  }, [recordData, form]);

  const leaveDuration = recordData?.lve_duration || 0;

  const onSubmit = (formData) => {
    try {
      const leaveId = formData.lve_id ?? recordData?.lve_id;

      leaveId > 0 &&
        (() => {
          if (action === "Approve") formData.typeId = LVE_APPROVED;
          if (action === "Reject") formData.typeId = LVE_DECLINED;

          formData.recordId = leaveId;

          doApproval(formData);
        })();
    } catch (error) {
      console.error("Save failed:", error);
    }
  };


  const submitIcon = action === "Approve" ? <CircleCheck /> : <CircleX />;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 text-[13px] py-4">
        <div className="pl-4">
          <p className="text-slate-700 mb-1">Leave Type</p>
          <span className={`status-indicator ${recordData?.lve_type_name?.toLowerCase().replace(/\s+/g, "-")}`}>
            {recordData?.lve_type_name}
          </span>
        </div>
        <div>
          <p className="text-slate-700 mb-1">Duration</p>
          <span className="font-medium">
            {leaveDuration} day{leaveDuration > 1 ? "s" : ""}
          </span>
        </div>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
      >
        <FormItem name="lve_id" hidden>
          <Input type="hidden" />
        </FormItem>
        
        <div className="grid grid-cols-1 px-4">
          <FormItem
            name="lve_notes"
            label={
              action === "Reject"
                ? "Reason for Rejection"
                : "Additional Notes (Optional)"
            }
            rules={
              action === "Reject"
                ? [requiredField()]
                : []
            }
          >
            <TextArea
              id="lve_notes"
              className="input-field"
              maxLength={255}
              placeholder={
                action === "Reject"
                  ? "Provide a reason for rejecting this request..."
                  : "Add any additional notes..."
              }
            />
          </FormItem>
        </div>

        <div className="px-4">
          {mode === "edit" && (
            <CrudButtons
              mode={mode}
              recordId={recordData?.lve_id || 0}
              isModal={true}
              modalId={`edit_leave_request_${action.toLowerCase()}_${recordData?.lve_id}`}
              cancelLabel="Cancel"
              doHideModal={onCancel}
              submitLabel={`${action} Request`}
              submitIcon={submitIcon} 
              moduleId={MODULE_LEAVE_REQUESTS}
            />
          )}
        </div>
      </Form>
    </div>
  );
};


const mapDispatchToProps = (dispatch) => ({
  doApproval: (data) => dispatch(doLeaveApproval(data)),
});

export default connect(null, mapDispatchToProps)(LeaveApprovalForm);
